import React from 'react';
import './Terms.css';

const Terms = () => {
  return (
    <div className="terms-page">
      {/* Hero Section */}
      <section className="terms-hero">
        <div className="container">
          <h1 className="terms-hero-title">Terms of Service</h1>
          <p className="terms-hero-subtitle">
            Last updated: January 2026
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="terms-content">
        <div className="container">
          <div className="terms-document">
            <div className="terms-section">
              <h2>1. Agreement to Terms</h2>
              <p>
                These Terms of Service constitute a legally binding agreement between you and Tinder, Inc. regarding your use of our Services. By accessing or using our Services, you agree to be bound by these Terms.
              </p>
              <p>
                If you are using our Services on behalf of an organization, you are agreeing to these Terms on behalf of that organization.
              </p>
            </div>

            <div className="terms-section">
              <h2>2. Eligibility</h2>
              <p>To use our Services, you must:</p>
              <ul>
                <li>Be at least 18 years old</li>
                <li>Not be prohibited from using the Services under applicable law</li>
                <li>Not have been previously suspended or removed from the Services</li>
                <li>Provide accurate and complete registration information</li>
              </ul>
            </div>

            <div className="terms-section">
              <h2>3. Account Registration</h2>
              <p>
                You must register for an account to use certain features of our Services. You are responsible for maintaining the confidentiality of your account credentials and for all activities under your account.
              </p>
              <p>
                You agree to notify us immediately if you become aware of any unauthorized use of your account.
              </p>
            </div>

            <div className="terms-section">
              <h2>4. User Content</h2>
              <p>
                You are solely responsible for the content you post on our Services. By posting content, you grant us a non-exclusive, royalty-free license to use, display, and distribute your content on our Services.
              </p>
              <p>You agree not to post content that:</p>
              <ul>
                <li>Is illegal, harmful, or offensive</li>
                <li>Infringes on the rights of others</li>
                <li>Contains spam or promotional material</li>
                <li>Impersonates another person</li>
                <li>Contains viruses or malicious code</li>
              </ul>
            </div>

            <div className="terms-section">
              <h2>5. Acceptable Use</h2>
              <p>You agree not to:</p>
              <ul>
                <li>Use the Services for any illegal purpose</li>
                <li>Harass, abuse, or harm other users</li>
                <li>Create multiple accounts</li>
                <li>Use automated systems to access the Services</li>
                <li>Interfere with the proper functioning of the Services</li>
                <li>Attempt to gain unauthorized access to our systems</li>
              </ul>
            </div>

            <div className="terms-section">
              <h2>6. Subscriptions and Payments</h2>
              <p>
                Some features require a paid subscription. By subscribing, you authorize us to charge your chosen payment method for the subscription fees.
              </p>
              <p>
                Subscriptions automatically renew unless you cancel before the renewal date. You may cancel your subscription at any time through your account settings.
              </p>
            </div>

            <div className="terms-section">
              <h2>7. Intellectual Property</h2>
              <p>
                The Services and all content, features, and functionality are owned by Tinder and are protected by copyright, trademark, and other intellectual property laws.
              </p>
              <p>
                Our trademarks may not be used without our prior written consent.
              </p>
            </div>

            <div className="terms-section">
              <h2>8. Termination</h2>
              <p>
                We may suspend or terminate your account at any time for any reason, including violation of these Terms. You may delete your account at any time through the app settings.
              </p>
              <p>
                Upon termination, your right to use the Services will immediately cease.
              </p>
            </div>

            <div className="terms-section">
              <h2>9. Disclaimer of Warranties</h2>
              <p>
                THE SERVICES ARE PROVIDED "AS IS" WITHOUT WARRANTIES OF ANY KIND. WE DO NOT WARRANT THAT THE SERVICES WILL BE UNINTERRUPTED, ERROR-FREE, OR SECURE.
              </p>
            </div>

            <div className="terms-section">
              <h2>10. Limitation of Liability</h2>
              <p>
                TO THE MAXIMUM EXTENT PERMITTED BY LAW, WE SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES.
              </p>
            </div>

            <div className="terms-section">
              <h2>11. Governing Law</h2>
              <p>
                These Terms shall be governed by the laws of the State of Texas, without regard to its conflict of law provisions.
              </p>
            </div>

            <div className="terms-section">
              <h2>12. Contact Us</h2>
              <p>
                If you have any questions about these Terms, please contact us at:
              </p>
              <p>
                <strong>Email:</strong> legal@tinder.com<br />
                <strong>Address:</strong> 8750 N. Central Expressway, Dallas, TX 75231
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Terms;
